import { TranslationsObject } from "@genericTypes/sharedTypes";
import { GQLAttachments, GQLTags, GQLUrls } from "@gql/types/gql";
import { translate } from "@helpers/translationObjectFormatter";
import {
    resolveNewsTagsColor,
    resolveURL,
    resolveNewsTagName,
    formatTimestamp,
} from "@lib/sharedUtils";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import Badge from "../badge/Badge";
import style from "./style.module.scss";
export interface INewsCardProps {
    url: GQLUrls;
    title: string;
    image: GQLAttachments;
    tags: GQLTags[];
    createdAt?: string;
    hideTag?: boolean;
}

const NewsCard = ({
    url,
    title,
    image,
    tags,
    createdAt,
    hideTag,
}: INewsCardProps) => {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);

    return (
        <a
            href={resolveURL(url)}
            className="flex flex-row sm:flex-col gap-4 max-w-[380px] sm:max-w-[300px] lg:max-w-[380px] hover:no-underline"
            key={title}
        >
            <div>
                <img
                    className="max-w-[150px] sm:max-w-[300px] lg:max-w-[380px]   sm:min-h-[200px] sm:max-h-[200px] lg:min-h-[250px] lg:max-h-[250px]"
                    src={image?.fullPath as string}
                    alt={title}
                />
                {createdAt && (
                    <span
                        className="text-sm mt-2 hidden lg:block"
                        style={{ color: "#4C4C4C" }}
                    >
                        {formatTimestamp(createdAt)}
                    </span>
                )}
            </div>
            <div className="flex flex-col gap-1 sm:gap-3">
                {createdAt && (
                    <span
                        className="block text-xs lg:hidden"
                        style={{ color: "#4C4C4C" }}
                    >
                        {formatTimestamp(createdAt)}
                    </span>
                )}
                {!hideTag && tags && tags.length > 0 && (
                    <Badge
                        text={
                            resolveNewsTagName(
                                tags as { name: string }[],
                            ) as string
                        }
                        variant={resolveNewsTagsColor(
                            resolveNewsTagName(
                                tags as { name: string }[],
                            ) as string,
                        )}
                        className="capitalize text-xs sm:text-base"
                    />
                )}
                <span
                    className={`${style.blogTitle} text-xs sm:text-lg font-bold text-black`}
                >
                    {title}
                </span>
                <span className="text-xs sm:text-base">
                    {translate(translations, "several_general_readMoreButton")}
                </span>
            </div>
        </a>
    );
};

export default NewsCard;
